import React from 'react';

import MacroVideo from '/react4xp/components/Macros/Video';

import { VideoProps } from '/lib/modules/video/index.d';

const MacroVideoEntry = (props: { videos: VideoProps[] }) => {
    return (
        <>
            {props.videos?.map((video, index) => (
                <MacroVideo key={index} {...video as any} />
            ))}
        </>
    )
}

export default MacroVideoEntry;
